import { useEffect } from 'react';
import { redirect } from 'react-router-dom';

import * as ROLES from '../constants/roles';
import { POLICY } from '../constants/routes';
import { useAuthContext } from '../pages/Posts/useAuthContext';

export const useAuth = () => {
    const { authUser: currentUser, authLoading, setAuthLoading } = useAuthContext();

    const isAdmin = !!currentUser && currentUser.role === ROLES.ADMIN;

    useEffect(() => {
        if (currentUser && !currentUser.acceptPolicy) {
            redirect(POLICY);
        }
    }, [currentUser]);

    return {
        currentUser: currentUser ? currentUser : {},
        isGuest: !currentUser,
        isAdmin,
        authLoading: authLoading,
        setAuthLoading: setAuthLoading,
    };
};
